import styled from "styled-components";

const Header = styled.div`
    font-size: 2em;
    font-weight: 500;
`;

export default Header;
